module.exports = __webpack_public_path__ + "static/media/download.d4c1391d.svg";